import { getDataConfig } from './init.js';

/**
 * Decrypt data function to be used in utils.
 *
 * - Frontend: Follows typical permissions rules.
 * - Backend: Decrypts data without restrictions.
 */

const decryptData = async data => {
  const {
    decryptData: configuredDecryptData
  } = getDataConfig('decryptData');
  return configuredDecryptData(data);
};
/** Encrypt data function to be used in utils. */

const encryptData = async (data, accessAttributes) => {
  const {
    encryptData: configuredEncryptData
  } = getDataConfig('encryptData');
  return configuredEncryptData(data, accessAttributes);
};
/** Get value once function to be used in utils. */

const getValueOnce = async ref => {
  const {
    getValueOnce: configuredGetValueOnce
  } = getDataConfig('getValueOnce');
  return configuredGetValueOnce(ref);
};

export { decryptData, encryptData, getValueOnce };
